import { ref } from "vue";

const savePlaylistButtonRef = ref();

const sharedRefs = {
  savePlaylistButtonRef
};

export default sharedRefs;